/** @jsxImportSource @emotion/react */
import { Trans, useLingui } from '@lingui/react/macro';
import { Zap } from 'lucide-react';
import React from 'react';
import UDAnimatedNumber from 'ud-ui/components/animated-number';
import UDCard from 'ud-ui/components/card';
import UDImage from 'ud-ui/components/image';
import UDText from 'ud-ui/components/text';
import { AnalyticsFastestGoalRecord } from 'modules/analytics/domain/interfaces/tournament-analytics';
import RecordCardShell from './record-card-shell';

interface FastestGoalCardProps {
  record: AnalyticsFastestGoalRecord | null;
  className?: string;
}

const FastestGoalCard = React.memo(({ record, className }: FastestGoalCardProps) => {
  const { t } = useLingui();
  const title = t`Самый быстрый гол`;
  const icon = <Zap size={20} />;

  if (record === null) {
    return <RecordCardShell icon={icon} title={title} tone="amber" isEmpty className={className} />;
  }

  // Параметр назван как в прежней строке перевода — её id не меняется.
  const formatSeconds = (goalSecond: number) => t`${goalSecond} сек.`;

  return (
    <RecordCardShell
      icon={icon}
      title={title}
      tone="amber"
      metric={{ label: t`Время гола`, value: <UDAnimatedNumber value={record.goalSecond} format={formatSeconds} /> }}
      championshipName={record.championshipName}
      matchDate={record.matchDate}
      className={className}
    >
      {/* Кто забил: та же плашка, что у матча в соседних карточках рекордов. */}
      <UDCard padding="none" className="flex min-w-0 items-center gap-3 px-3 py-4" data-testid="record-scorer">
        <UDImage url={record.playerPhotoUrl} shape="circle" />
        <div className="min-w-0">
          <UDText variant="body-2" as="div" className="!text-inkSecondary">
            <Trans>Автор гола</Trans>
          </UDText>
          <UDText variant="text-2-bold" relaxed as="div" className="!text-inkPrimary line-clamp-2 break-words">
            {record.playerName}
          </UDText>
        </div>
      </UDCard>
    </RecordCardShell>
  );
});

export default FastestGoalCard;
